import { useEffect, useState } from "react";
import CheckboxCell from "../../common/interactive/CheckboxCell";
import { retriveAllCaseFlags } from "../../../lib/systemData";
import { objectHasOwnProperty } from "../../../lib/script";

export default function ExceptionsGroupSelectAll({selectAllHandlerMiddleware, item, exceptionValues, workQ}) {
    const [areAllSelected, setAreAllSelected] = useState(false)
    

    useEffect(() => {
        if (exceptionValues && exceptionValues.case_flags && Object.keys(exceptionValues?.case_flags).length && retriveAllCaseFlags()) {   
            let truthArray = []
            for (const [key, value] of Object.entries(exceptionValues?.case_flags)) {   

                let group = item.filters.filter(elem => objectHasOwnProperty(workQ.exceptions_filters, elem.key))
                
                group.forEach((item) => {
                    truthArray.push(exceptionValues?.case_flags[item.key])
                })                        
                
            }

            if (truthArray.some(item => !item)) {
                setAreAllSelected(false)              
            } else {
                setAreAllSelected(true)
            }
        }
    }, [exceptionValues, workQ, item])

    function changehandler(value) {
        setAreAllSelected(value?.data?.value)

        if (selectAllHandlerMiddleware) {
            selectAllHandlerMiddleware(value)
        }
    }
    return <>
        <CheckboxCell checked={areAllSelected} label={'Select All'} direction={'reverse'} setStyle={'box_small'} action={changehandler} identifier={{type: item.group}}/>
    </>
}